module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/female_consulter_resolved-2e229a2e88a3c486e8210099c415302f.png";